// extracted by mini-css-extract-plugin
export default {"smallScreen":"SmallScreen_smallScreen__3KnyT"};